import { MenuItem } from './MenuItem'
import { MenuSubItem } from '../menuTypes'

export type MenuColumnProps = {
  rows: MenuSubItem[]
  setIsModalOpen?: (status: boolean) => void
}

export function MenuColumn({
  rows,
  setIsModalOpen = () => {},
}: MenuColumnProps) {
  return (
    <div className='flex flex-col'>
      {rows.map((row, rowIndex) => (
        <MenuItem
          key={row.name}
          row={row}
          rowIndex={rowIndex}
          setIsModalOpen={setIsModalOpen}
        />
      ))}
    </div>
  )
}
